
import React from 'react';
import { Interview } from '@/types/interview';
import { TableRow, TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Trash2 } from 'lucide-react';
import { format } from 'date-fns';
import { nb } from 'date-fns/locale';

interface PublishedInterviewRowProps {
  interview: Interview;
  onViewInterview: (interview: Interview) => void;
  onDepublish: (interviewId: string) => void;
  onDelete: (interviewId: string) => void;
  isProcessing: boolean;
}

const PublishedInterviewRow: React.FC<PublishedInterviewRowProps> = ({
  interview,
  onViewInterview,
  onDepublish,
  onDelete,
  isProcessing
}) => {
  // Format the publication date in Norwegian format
  const formatPublicationDate = (timestamp: string) => {
    try {
      return format(new Date(timestamp), 'dd. MMMM yyyy', { locale: nb }); // e.g., "29. april 2023"
    } catch (e) {
      return 'Ukjent dato';
    }
  };

  // Format the publication time in 24-hour format
  const formatPublicationTime = (timestamp: string) => {
    try {
      return format(new Date(timestamp), 'HH:mm'); // e.g., "14:30" for 24-hour format
    } catch (e) {
      return 'Ukjent tid';
    }
  };
  
  // Use timestamp (publication date) as primary, updated_at as fallback
  const publicationTime = interview.timestamp || interview.updated_at || '';
  
  return (
    <TableRow key={interview.id}>
      <TableCell className="font-medium">{interview.intervieweeName}</TableCell>
      <TableCell>{interview.company}</TableCell>
      <TableCell>
        <span>{formatPublicationDate(publicationTime)}</span>
      </TableCell>
      <TableCell>
        <span>{formatPublicationTime(publicationTime)}</span>
      </TableCell>
      <TableCell>
        <div className="flex space-x-2">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onViewInterview(interview)}
          >
            Vis
          </Button>
          <Button 
            variant="outline" 
            size="sm"
            className="text-amber-600 border-amber-200 bg-amber-50 hover:bg-amber-100"
            onClick={() => onDepublish(interview.id)}
            disabled={isProcessing}
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Flytt til ventende
          </Button>
          <Button 
            variant="outline" 
            size="sm"
            className="text-red-600 border-red-200 bg-red-50 hover:bg-red-100"
            onClick={() => onDelete(interview.id)}
            disabled={isProcessing}
          >
            <Trash2 className="h-4 w-4 mr-1" />
            Slett artikkel
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default PublishedInterviewRow;
